import { useMutation } from "@tanstack/react-query";

import axios from "../../../utils/axiosInceptor";
import { apiV1Endpoint } from "../endpoints";
import { ApiResponse } from "../types";

type PatchOrganizationOptions<TData = unknown> = {
  orgId: string;
  data?: TData;
};

export async function patchOrganization<TData = unknown>(options: PatchOrganizationOptions<TData>) {
  const { orgId, data } = options;

  const url = `${apiV1Endpoint}/organization/${orgId}`;

  const response = await axios.patch<ApiResponse>(url, data);
  return response.data;
}

export function usePatchOrganization() {
  return useMutation<ApiResponse, unknown, PatchOrganizationOptions>({
    mutationFn: patchOrganization,
  });
}
